document.addEventListener("DOMContentLoaded", () => {

    const cards = document.querySelectorAll(".swad-pack-card");

    cards.forEach(card => {

        card.addEventListener("click", () => {

            // Active state
            cards.forEach(c=>c.classList.remove("active"));
            card.classList.add("active");

            const value = card.dataset.value;

            // Original Radio
            const radio=document.querySelector(
                `.product-form__input input[value="${value}"]`
            );

            if(radio){

                radio.checked=true;

                radio.click();

                radio.dispatchEvent(new Event("change",{
                    bubbles:true
                }));

            }

            // Original Select
            const select=document.querySelector(
                ".product-form__input select"
            );

            if(select){

                select.value=value;

                select.dispatchEvent(new Event("change",{
                    bubbles:true
                }));

            }

        });

    });

});